export const StatCard = ({ icon: Icon, label, value, hint, testId, tone = "navy" }) => {
  const tones = {
    navy: "bg-navy/5 text-navy",
    green: "bg-brand/10 text-brand",
    red: "bg-rose-50 text-rose-600",
  };
  return (
    <div data-testid={testId} className="min-w-0 rounded-2xl bg-white p-4 sm:p-5 shadow-[0_1px_3px_rgba(11,37,69,0.06)] animate-in fade-in slide-in-from-bottom-2 duration-500">
      <div className="flex items-center justify-between gap-3">
        <span className="min-w-0 break-normal text-xs font-medium uppercase leading-tight tracking-wide text-slate-500">{label}</span>
        {Icon && (
          <span className={`grid h-9 w-9 shrink-0 place-items-center rounded-xl ${tones[tone]}`}>
            <Icon className="h-4 w-4" />
          </span>
        )}
      </div>
      <div className="mt-3 whitespace-nowrap text-xl font-semibold tabular-nums sm:text-2xl text-navy" data-testid={testId ? `${testId}-value` : undefined}>
        {value}
      </div>
      {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
    </div>
  );
};
